import React from 'react';
import {noop} from 'lodash';

import {PinInput} from '../../PinInput';

import {useEnterPinInput} from './EnterPinInput.hook';

// Define props interface
interface EnterPinInputProps {
  theme: string;
  textVariant: string;
  enterTitle: string;
  errorTitle: string;
  checkPinCode: (pin: string) => boolean | Promise<boolean>;
  skipButton: () => void;
  handlePinLogin: () => void;
  onSubmit: () => void;
  lastPaidRank: string;
  onSuccess: () => void;
}

export const EnterPinInput: React.FC<EnterPinInputProps> = ({
  theme = 'dark',
  textVariant = 'heading',
  enterTitle = '',
  errorTitle = '',
  checkPinCode,
  skipButton,
  handlePinLogin,
  onSubmit,
  lastPaidRank = '',
  onSuccess = noop,
}: any) => {
  const {getText, onInputPin, onInputComplete, pinStatus} = useEnterPinInput({
    enterTitle,
    errorTitle,
    checkPinCode,
    onSubmit,
    lastPaidRank,
    onSuccess,
  });

  return (
    <PinInput
      autoFocus={true}
      theme={theme}
      textVariant={textVariant}
      title={getText()}
      onInputPin={onInputPin}
      onInputComplete={onInputComplete}
      status={pinStatus}
      // @ts-expect-error TS(2322): Type '{ autoFocus: true; theme: any; textVariant: ... Remove this comment to see the full error message
      skipButton={skipButton}
      onSubmit={onSubmit}
      handlePinLogin={handlePinLogin}
    />
  );
};
